/**
 * Password reset and invitation e-mails sent before this admin (and Contember's own default templates) link to
 * `/?page=passwordReset&token=…`. The reset page lives at `/login/password-reset?token=…`.
 *
 * This runs in bootstrap, before the router starts: done as a navigation inside the app, it raced the `(app)` layout,
 * whose redirect of a signed-out visitor to `/login` could cancel it and lose the token.
 *
 * Returns the URL to replace the current one with, or null when `url` is not a legacy reset link.
 */
export const legacyResetLinkTarget = (url: string): string | null => {
	const { searchParams } = new URL(url, 'http://localhost')
	if (searchParams.get('page') !== 'passwordReset') {
		return null
	}
	const token = searchParams.get('token')
	return token ? `/login/password-reset?${new URLSearchParams({ token })}` : '/login/password-reset'
}
